/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Failed_To_Extract_AudioInputs */



/**
* | output |
* | --- |
* | "Failed to extract audio from source file" |
*
* @param {Failed_To_Extract_AudioInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const failed_to_extract_audio = /** @type {((inputs?: Failed_To_Extract_AudioInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failed_To_Extract_AudioInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de l’extraction audio du fichier source")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Extrahieren der Audiodatei aus der Quelldatei")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile estrarre l'audio dal file sorgente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось извлечь аудио из исходного файла.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo extraer el audio del archivo fuente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("无法从源文件中提取音频")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ソースファイルからオーディオを抽出できませんでした")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्रोत फ़ाइल से ऑडियो निकालने में विफल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Falha ao extrair o áudio do arquivo de origem")
	return /** @type {LocalizedString} */ ("Failed to extract audio from source file")
});